import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import Immutable, { Iterable } from 'immutable';

import rootSaga from '../sagas';
import rootReducer from '../reducers';

const initialState = new Immutable.Map();

const stateTransformer = state => {
  if (Iterable.isIterable(state)) return state.toJS();
  else return state;
};

const logger = createLogger({
  stateTransformer
});

const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];
if (process.env.NODE_ENV !== 'production') {
  middleware.push(logger);
}
const enhancer = applyMiddleware(...middleware);
const store = createStore(rootReducer, initialState, enhancer);
sagaMiddleware.run(rootSaga);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js